import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';

import { Configuration } from '../models/configuration.model';
import { ConfigService } from '../config.service';

@Injectable()
export class Api {
  private config: Configuration;
  private authHeader: string;
  private options: RequestOptions;

  constructor(public http: Http,
              private configService: ConfigService) {
    this.init();
  }

  public get(endpoint: string, params?: any, options?: RequestOptions) {
    options = this.handleOptions(options);
    // Support easy query params for GET requests
    if (params) {
      let p = new URLSearchParams();
      for (let k in params) {
        p.set(k, params[k]);
      }
      // Set the search field if we have params and don't already have
      // a search field set in options.
      options.search = !options.search && p || options.search;
    }

    return this.http.get(this.config.backendUrl + '/' + endpoint, options);
  }

  public post(endpoint: string, body: any, options?: RequestOptions) {
    options = this.handleOptions(options);
    return this.http.post(this.config.backendUrl + '/' + endpoint, body, options);
  }

  public put(endpoint: string, body: any, options?: RequestOptions) {
    options = this.handleOptions(options);
    return this.http.put(this.config.backendUrl + '/' + endpoint, body, options);
  }

  public delete(endpoint: string, options?: RequestOptions) {
    options = this.handleOptions(options);
    return this.http.delete(this.config.backendUrl + '/' + endpoint, options);
  }

  public patch(endpoint: string, body: any, options?: RequestOptions) {
    options = this.handleOptions(options);
    return this.http.put(this.config.backendUrl + '/' + endpoint, body, options);
  }

  private handleOptions(options: RequestOptions): RequestOptions {
    if(!options) {
      options = Object.assign(new RequestOptions(), this.options);
    } else {
      options.headers.append('Authorization', this.authHeader);
    }
    return options;
  }

  private init() {
    this.config = this.configService.getConfiguration();
    this.authHeader = 'Basic ' + btoa(this.config.user.email + ':' + this.config.user.password);
    const headers = new Headers();
    headers.append('Authorization', this.authHeader);
    this.options = new RequestOptions({
      headers: headers
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/api.ts